export const getTimeout = (): number => {
  const timeout = process.env.REACT_APP_GENERAL_TIMEOUT;

  return timeout ? Number(timeout) : 5000;
};

export const customerStatuses = [
  { value: 'NON_CLIENT' },
  { value: 'POTENTIAL' },
  { value: 'CLIENT' },
  { value: 'REJECTED' },
  { value: 'OFFBOARDED' },
];

export const allowedStatuses = (currentStatus: string): {value: string}[] => {
  const indexOfCurrent = customerStatuses.findIndex(status => status.value === currentStatus)
  switch (indexOfCurrent) {
    case 0: {
      return [{ value: 'POTENTIAL' }]
    }
    case 1: {
      return [{ value: 'CLIENT' }, { value: 'REJECTED' }]
    }
    case 2: {
      return [{ value: 'OFFBOARDED' }]
    }
    case 3: {
      return [{ value: 'POTENTIAL' }]
    }
    case 4: {
      return [{ value: 'POTENTIAL' }]
    }
    default:
      return customerStatuses
  }
}
